import { render, staticRenderFns } from "./BulkRepairIndex.vue?vue&type=template&id=47bc26be&scoped=true&"
import script from "./BulkRepairIndex.vue?vue&type=script&lang=js&"
export * from "./BulkRepairIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47bc26be",
  null
  
)

export default component.exports